import React, {Component} from 'react';
import axios from 'axios';
import classes from './Subs.css';
import Tile from '../Tile/Tile';

class Subs extends Component{
    state = {
        subsList : []
    }
    subsECE = [
        'Analog Comm Engineering',
        'Antenna & Wave Propagation',
        'Basic Electronics',
        'Comm & Data Networks',
        'Control Systems',
        'Digital Communication Engineering',
        'Digital Electronics',
        'Digital System Design using Verilog',
        'Electronic Circuits & Simulation',
        'Embedded Systems & Microcontroller',
        'Linear Integrated Circuits & Apps',
        'Microprocessor Systems',
        'Microprocessors & Interfacing',
        'Microwave Engineering',
        'Multimedia Communication',
        'Network Analysis & Synthesis',
        'Signal Processing & Linear System' ];
    subsCSE = [
        'Computer Network & Comm',
        'Computer Org & Arch',
        'Design & Analysis of Algo',
        'Database Management System',
        'Data Structures using C',
        'OOP with C++',
        'Operating System',
        'Programming with C',
        'Programming in Python',
        'Theory of Computation' ];
    subsMECH = [
        'Dynamics of Machines',
        'Engineering Graphics with CAD',
        'Engineering Mechanics',
        'Fluid Machines',
        'Fluid Mechanics',
        'Kinematics of Machines',
        'Machine Design',
        'Machine Drawing',
        'Manufacturing Processes',
        'Materials Science & Engineering',
        'Mechanics of Materials',
        'Operations Research',
        'Strength of Materials',
        'Thermal Engineering',
        'Thermodynamics',
        'Workshop Practice' ];
    subsCE = [
        'Concrete Technology',
        'Fluid Mechanics-I',
        'Geotechnical Engineering-I',
        'Strength Of Materials' ];
    subsEEE = [
        'Basic Electrical',
        'Electrical Machine-I',
        'Elec. Measurement and Inst.',
        'Fundamentals of Electrical Engg.'   ];
    subsMAT = [
        'Discrete Structures',
        'Engg. Comp. Methods',
        'Engineering Mathematics - I',
        'Engineering Mathematics - II',
        'Integral Transform & Comp Analysis' ];
    subsPHIL = [
        'Constitution of India',
        'Discourse on Human Virtues',
        'Intro to Human Rights',
        'Introduction to Logic' ];
    subsOTH = [
        'Engineering Physics',
        'Entrepreneurship Management',
        'Environmental Studies',
        'Professional Communication'    ];
    componentWillMount () {        
        switch (this.props.deptName) {
            case('CSE'):
                this.setState({subsList : this.subsCSE});
                break;
            case('ECE'):
                this.setState({subsList : this.subsECE});
                break;
            case('MECH'):
                this.setState({subsList : this.subsMECH});
                break;
            case('EEE'):
                this.setState({subsList : this.subsEEE});
                break;
            case('CE'):
                this.setState({subsList : this.subsCE});
                break;
            case('MAT'):
                this.setState({subsList : this.subsMAT});
                break;
            case('PHIL'):
                this.setState({subsList : this.subsPHIL});
                break;
            case('OTH'):
                this.setState({subsList : this.subsOTH});
                break;
            default:                
                this.setState({subsList : this.subsCSE});
        }
    }
        
    render () {
        const openFile = (subName) => {
            let dnld = 0
            axios.get( 'https://kal-exam-hai.firebaseio.com/downloads/' + this.props.deptName + '/' + subName + '.json' )
            .then( response => { dnld=response.data } )
            axios.post( 'https://kal-exam-hai.firebaseio.com/downloads/' + this.props.deptName + '/' + subName + '.json', dnld )
        };
        const Subjects = (
            this.state.subsList.map(subName => {
                return ( <a href={require('../../../../assets/' + this.props.deptName + '/' + subName + '.pdf')} target="_blank" rel="noopener noreferrer" download={subName + '.pdf'}><Tile type='Subject' key={subName} ele={subName} clicked={openFile}/></a>
        )}));
        return (
            <div className = {classes.Subs}>
                {Subjects}
            </div>
        )
    }
}

export default Subs;


// WEBPACK FOOTER //
// ./src/components/Contents/Lists/Subs/Subs.js